// extracted by mini-css-extract-plugin
module.exports = {"searchWrp":"followingSearch_searchWrp__1SCk5","searchIco":"followingSearch_searchIco__37Wzk","searchInput":"followingSearch_searchInput__2ABim","btn":"followingSearch_btn__2ZPCK"};